export default function CardImgSecond({ prefixCls, pc, h5 }: { prefixCls: string; pc: string; h5: string }) {
    const styleA: any = {};
    if (pc) {
        styleA['--ef-img-pc'] = `url('${pc}')`;
    }
    if (h5) {
        styleA['--ef-img-h5'] = `url('${h5}')`;
    }
    return (
        <div className={`${prefixCls}-imgA`} style={styleA}>
            {!!h5 && <figure className={`${prefixCls}-imgA-item ${prefixCls}-imgA-item-h5`}></figure>}
            <figure className={`${prefixCls}-imgA-item ${prefixCls}-imgA-item-pc`}></figure>
        </div>
    );
}
